<template>
  <content-card
    class="c-content-product-card"
    v-bind="{
      ...$props,
      imageHeight: '300px',
      imageWidth: '300px',
      cta: productCta,
      description: productPrice,
      image: productImage,
      newBadge: productNewBadge,
      title: productTitle,
      titleTypography: 't-heading-6'
    }"
  >
    <template v-if="product && productAddToCartEnabled">
      <product-info-size
        :product="product"
        :size.sync="size"
        :is-gift-card="isGiftCard"
      />
      <btn
        class="c-content-product-card__add-to-cart-button"
        :disabled="!size"
        :is-disabled="!size"
        @click="addToCart"
      >
        <span v-if="size">
          <span v-if="justAddedToCart"> Add another? </span>
          <span v-else> Add to Cart </span>
        </span>
        <span v-else> Select Size </span>
      </btn>
    </template>
  </content-card>
</template>
<script>
import Btn from '../button/Btn'
import ContentCard from "./ContentCard";
import get from 'lodash/get'
import ProductInfoSize from '../productInfo/ProductInfoSize'
import { getVariant, getLineItem } from '@/utils/shopifyHelper'
export default {
  components: {
    Btn,
    ContentCard,
    ProductInfoSize,
  },
  props: {
    backgroundColor: {
      type: String,
      default: '',
    },
    backgroundImage: {
      type: Object,
      default: () => ({
        src: '',
        alt: 'background image',
      })
    },
    textAlignment: {
      type: String,
      default: 'center',
    },
    mobileTextAlignment: {
      type: String,
      default: '',
    },
    image: {
      type: Object,
      default: ()=> ({}),
    },
    video: {
      type: Object,
      default: null,
    },
    imageHeight: {
      type: String,
      default: '',
    },
    imageWidth: {
      type: String,
      default: '',
    },
    cta: {
      type: Object,
      default: null
    },
    whiteText: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: '',
    },
    subtitleTypography: {
      type: String,
      default: 't-heading-5'
    },
    subtitleMarginBottom: {
      type: String,
      default: 'xx-small'
    },
    handwritingSubtitleMarginBottom: {
      type: String,
      default: 'small'
    },
    subtitleFont: {
      type: String,
      default: 'Poppins'
    },
    subtitleColor: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: '',
    },
    descriptionsTypography: {
      type: String,
      default: ''
    },
    descriptionMarginBottom: {
      type: String,
      default: 'medium'
    },
    descriptionColor: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    titleMarginBottom: {
      type: String,
      default: 'x-small'
    },
    titleTypography: {
      type: String,
      default: 't-heading-7'
    },
    titleColor: {
      type: String,
      default: '',
    },
    buttonType: {
      type: String,
      default: 'link',
    },
    featured: {
      type: Boolean,
      default: false,
    },
    titleLogo: {
      type: Object,
      default: ()=>{}
    },
    belowButtonText: {
      type: String,
      default: '',
    },
    belowButtonTextColor: {
      type: String,
      default: ''
    },
    belowButtonTextMarginBottom: {
      type: String,
      default: ''
    },
    cardClickable: {
      type: Boolean,
      default: false
    },
    // Product Card specific items
    productHandle: {
      type: String,
      default: ''
    },
    getProductFunction: {
      type: Function,
      required: true
    },
    productAddToCartEnabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      product: null,
      size: null,
      justAddedToCart: false,
    }
  },
  computed: {
    productImage() {
      let product = this.product
      let result = null
      if (product) {
        result = {
          src: get(product, 'featuredMedia.src')
        }
      }
      return result
    },
    productTitle() {
      let product = this.product
      let result = null
      if (product) {
        result = get(product, 'title')
      }
      return result
    },
    productPrice() {
      let product = this.product;
      let price = ''
      if (product) {
        price = '$' + product.variants[0].price
      }
      return price
    },
    productCta() {
      let product = this.product
      let cta = this.cta
      let result = {}
      if (product && product.handle) {
        result = { ...cta, url: `/products/${product.handle}` }
      }
      return result
    },

    isGiftCard() {
      return (
        this.product &&
        this.product.vendor &&
        this.product.vendor.toLowerCase() === "rise.ai"
      )
    },
    productNewBadge() {
      let product = this.product;
      return (this.product && (product.tags.includes("new-arrivals") || product.tags.includes("new-arrival")));
    },
  },
  watch: {
    productHandle() {
      if(this.productHandle){
        this.getProduct()
      }
    }
  },
  mounted() {
    if(this.productHandle) {
      this.getProduct()
    }
  },
  methods: {
    async getProduct() {
      try {
        this.product = await this.getProductFunction(this.productHandle)
      } catch (err) {
        console.error('[content-product-card]', err)
      }
    },
    async addToCart() {
      if (this.product && this.size) {
        const variant = getVariant(this.product, this.size)
        if (variant) {
          try {
            await this.$store.dispatch(
              'cart/addLineItem',
              getLineItem(this.product, variant)
            )
            this.justAddedToCart = true
            await this.$store.dispatch('cart/showCart')
            setTimeout(() => {
              this.justAddedToCart = false
            }, 2000)
          } catch (err) {
            console.error('[content-product-card]', err)
          }
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.c-content-product-card {}
</style>
